import { createWebHistory, createRouter } from 'vue-router'
import myRouter from './constant/myRouter'
import goodsRouter from './constant/goodsRouter'
import cashierRoutes from './constant/cashier'
import cashLoan from './constant/cashLoanRouter'
import memberRouter from './constant/memberRouter'
import marketing from './constant/marketing'
import integralRoutes from './constant/integral'
import downloadRoutes from './constant/downloadRouter'
import testRoutes from './constant/test'
import consumerFinanceRouter from './constant/consumerFinanceRouter'
import productRoutes from './constant/product'
// 公共路由
export const basicRoutes = [
  {
    path: '/',
    name: 'Main',
    meta: {
      index: 0,
      keepAlive: 1
    },
    component: () => import('@/views/Main.vue')
  },
  {
    path: '/base-search',
    name: 'BaseSearch',
    meta: {
      index: 1
    },
    component: () => import('@/views/base/Search.vue')
  },
  {
    path: '/my',
    name: 'My',
    meta: {
      index: 0
    },
    component: () => import('@/views/my/Index.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue')
  },
  {
    path: '/register',
    name: 'Register',
    meta: {
      index: 1
    },
    component: () => import('@/views/Register.vue')
  },
  {
    path: '/user-bankcard',
    name: 'UserBankCard',
    meta: {
      index: 42
    },
    component: () => import('@/views/user/bankcard/Index.vue')
  },
  {
    path: '/user-supplement',
    name: 'UserSupplement',
    meta: {
      index: 43,
      title: '补充信息'
    },
    component: () => import('@/views/user/supplement/Index.vue')
  },
  {
    path: '/credit-facilities',
    name: 'CreditFacilities',
    meta: {
      index: 44
    },
    component: () => import('@/views/creditFacilities/Index.vue')
  },
  {
    path: '/cust-info-result',
    name: 'CustInfoResult',
    meta: {
      index: 46
    },
    component: () => import('@/views/custInfo/Result.vue')
  },
  {
    path: '/cust-info',
    name: 'CustInfo',
    meta: {
      index: 48
    },
    component: () => import('@/views/custInfo/Index.vue')
  },
  {
    path: '/active-agreement',
    name: 'ActiveAgreement',
    meta: {
      index: 48
    },
    component: () => import('@/views/active/ActiveAgreement.vue')
  },
  {
    path: '/active-loading',
    name: 'ActiveLoading',
    meta: {
      index: 50
    },
    component: () => import('@/views/active/Loading.vue')
  },
  {
    path: '/active-finish',
    name: 'ActiveFinish',
    meta: {
      index: 52
    },
    component: () => import('@/views/active/Finish.vue')
  },
  {
    path: '/installment',
    name: 'Installment',
    meta: {
      index: 36
    },
    component: () => import('@/views/installment/Index.vue')
  },

  {
    path: '/message-notify',
    name: 'messageNotify',
    meta: {
      index: 10
    },
    component: () => import('@/views/messageNofity/Index.vue')
  },
  {
    path: '/integral',
    name: 'Integral',
    meta: {
      index: 1
    },
    component: () => import('@/views/integral/Index.vue')
  },
  {
    path: '/download/product',
    name: 'downloadProduct',
    meta: {
      index: 101
    },
    component: () => import('@/views/download/Product.vue')
  },
  {
    path: '/download/register',
    name: 'downloadRegister',
    meta: {
      index: 102
    },
    component: () => import('@/views/download/Register.vue')
  },
  {
    path: '/external-redirect',
    name: 'ExternalRedirect',
    meta: {
      index: 103
    },
    component: () => import('@/views/externalRedirect/Index.vue')
  }
]
const constantRoutes = basicRoutes.concat(
  myRouter,
  goodsRouter,
  cashierRoutes,
  cashLoan,
  marketing,
  memberRouter,
  integralRoutes,
  downloadRoutes,
  consumerFinanceRouter,
  productRoutes,
  testRoutes
)
const router = createRouter({
  history: createWebHistory(),
  routes: constantRoutes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

export default router
